<template>
  <div
    class="index"
    :style="{ 'padding-bottom': active === 0 ? '.433rem' : '.4rem' }"
  >
    <a v-if="v_key=='RVtzS'" class="aiBox" href="https://robot.chaoxing.com/chatDigitalHuman?unitId=183837&robotId=010d882e1dda429dbab8988f4f9bcbe7" style="position: fixed;right:0.3rem;bottom:2rem;z-index: 9999; ">
      <img :src="aiImg" style="width: 1.5rem;" alt="">
    </a>
    <div class="home-search-wrapper">
      <input type="text" readonly v-model="unitName" />
      <div class="search-btn" @click="to('/search')">
        <img src="./img/search-btn.png" alt="" />
      </div>
    </div>
    <div class="tab">
      <van-tabs
        v-model="active"
        @click="onClick"
        color="#333333"
        line-width="0.427rem"
        line-height="0.067rem"
        :swipe-threshold="4"
      >
        <van-tab title="首页" :name="0" key="index0"></van-tab>
        <van-tab
          :title="item.course_type"
          :name="item.id"
          v-for="item in typeList"
          :key="item.id"
        ></van-tab>
      </van-tabs>
      <div class="shadow"></div>
    </div>
    <div class="index-content" v-show="active === 0">
      <div class="home-fixed-sections">
        <div class="banner">
          <van-swipe class="my-swipe" :autoplay="3000">
            <van-swipe-item v-for="item in banner" :key="item.id">
              <a :href="item.url">
                <div class="img-content">
                  <img :src="item.cover_img" alt="" />
                </div>
              </a>
            </van-swipe-item>
          </van-swipe>
        </div>
        <ul class="nav">
          <li @click="to('/category')">全部分类</li>
          <li @click="to('/teacherList')">名师推荐</li>
          <li @click="to('/hot-list/1')">热播榜</li>
          <li @click="to('/me')">我的慕课</li>
        </ul>
        <div class="fixed-data">
          <div
            class="recently-updated"
            v-if="lastContent.length > 0 && recent_updates == 1"
          >
            <div class="big-title">
              <span>最近更新</span>
              <div class="more" @click="to('/updata-list')">更多</div>
            </div>
            <div class="updated-swiper">
              <div class="swiper-container" ref="swiperContainer">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="item in lastContent"
                    :key="item.id"
                    @click="$router.push('/lesson-detail/' + item.id)"
                  >
                    <div class="img-content">
                      <img :src="item.cover_img" alt="" />
                      <div class="chapter">{{ item.chapter_num }}讲</div>
                      <div class="info">
                        <div class="title">
                          <div class="o2">{{ item.title }}</div>
                        </div>
                        <div class="teacher">
                          <div class="teacher-name">
                            <div class="teacher-thumb">
                              <img v-if="item.avatar" :src="item.avatar" alt="" />
                              <img
                                v-else
                                src="../../../static/img/default-teacher.png"
                                alt=""
                              />
                            </div>
                            <div class="o1">{{ item.teacher }}</div>
                          </div>
                          <div class="job o1">{{ item.teacher_title }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="art-classroom"
            v-if="nineContent.length > 0 && art_class == 1"
          >
            <div class="big-title">
              <span>90分钟艺课堂</span>
              <div class="more" @click="to('/hot-list/2')">更多</div>
            </div>
            <ul class="art-list">
              <li
                v-for="item in nineContent"
                :key="item.id"
                @click="$router.push('/lesson-detail/' + item.id)"
              >
                <div class="img-content">
                  <img :src="item.cover_img" alt="" />
                </div>
                <div class="list-content">
                  <div class="title o1">{{ item.title }}</div>
                  <div class="hits">{{ item.play_num }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="temp-data">
        <listtemplate
          v-for="(item, index) in templatedata"
          :tem_data="item"
          :cindex="index"
          :key="item.id"
        ></listtemplate>
      </div>
      <div class="all-lesson" @click="to('/lesson-list/1/0')">查看全部课程>></div>
    </div>
    <div class="tab-content" v-show="active !== 0">
      <ul class="tab-list">
        <li
          v-for="item in secondType"
          :key="item.id"
          @click="to('/lesson-list/' + '1/' + item.id)"
        >
          <div class="img-content">
            <img :src="item.cover_img || primaryIcon" alt="" />
          </div>
          <div class="name">{{ item.course_type }}</div>
        </li>
      </ul>
      <div class="course-list">
        <div class="small-title">
          <span>全部</span>
          <div class="more" style="display:none;">更多</div>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :offset="50"
        >
          <ul class="course-list-scrool">
            <li
              v-for="item in courseList"
              :key="item.id"
              @click="$router.push('/lesson-detail/' + item.course_id)"
            >
              <div class="img-content">
                <img :src="item.cover_img" alt="" />
                <div class="chapter">{{ item.chapter_num }}讲</div>
              </div>
              <div class="info">
                <div class="title">
                  <div class="o2">{{ item.course_title }}</div>
                </div>
                <div class="teacher" v-if="item.course_teachers[0]">
                  <div class="teacher-name">
                    <div class="teacher-thumb">
                      <img
                        v-if="item.course_teachers[0].avatar"
                        :src="item.course_teachers[0].avatar"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../../static/img/default-teacher.png"
                        alt=""
                      />
                    </div>
                    <div class="o1">
                      {{ item.course_teachers[0].nick_name }}
                    </div>
                  </div>
                  <div class="job o1" v-if="item.course_teachers[0].department">
                    {{ item.course_teachers[0].department }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import tools from "../../util/tools.js";
import listtemplate from "../list-template/list-template.vue";
import $ from "jquery";
import "swiper/css/swiper.css";
import aiImg from "../../../static/img/ai.png"
import primaryIcon from "../../asset/img/account/primary_icon.png";

const SPECIALIZED_COURSES_TEMPLATE = `<div class="specialized-courses">
          <div class="big-title">
            <span>{{title}}</span>
            <div class="more" onclick="routerlink('/lesson-list/{{more}}/{{id}}')">更多</div>
          </div>
          <ul class="special-list">
            {{#each list}}
            <li onclick="routerlink('/topic/{{id}}')">
              <div class="img-list">
                  <div class="border1"></div>
                  <div class="border2"></div>
                  <div class="img-content">
             {{#if mobile_cover_img}}
            <img src="{{mobile_cover_img}}" alt="" />
            {{else}}
                <img src="{{cover_img}}" alt="" />
            {{/if}}
                  </div>
                </div>
                <div class="special-content">
                  <div class="title o1">{{title}}</div>
                  <div class="chapter">{{course_num}}门课</div>
                   {{#if play_num}}
                  <div class="play">{{play_num}}次播放</div>
                   {{/if}}
                </div>
            </li>
             {{/each}}
          </ul>
        </div>`;

const RECOMMEND_TEMPLATE = `<div class="recommend">
          <div class="big-title">
            <span>{{title}}</span>
            <div class="more" onclick="routerlink('/lesson-list/{{more}}/{{id}}')">更多</div>
          </div>
          <div class="recommend-swiper">
            <div class="swiper-container recommendContainer">
              <div class="swiper-wrapper">
                 {{#grouped_each list 3}}
                <div class="swiper-slide">
                  {{#each this}}
                  <div class="swiper-item" onclick="routerlink('/lesson-detail/{{id}}')">
                    <div class="img-content">
                        <img src="{{cover_img}}" alt="" />
{{#if play_num}}
                        <div class="hits">
                          <span>{{play_num}}</span>
                        </div>
 {{/if}}
                      </div>
                      <div class="info">
                        <div class="title">
                          <div class="o2">{{title}}</div>
                        </div>
                        <div class="name o1">{{teacher}}</div>
                        <div class="school o1">{{department}}</div>
                      </div>
                  </div>
                  {{/each}}
                </div>
                 {{/grouped_each}}
              </div>
            </div>
          </div>
        </div>`;

const CULTURAL_LITERACY_TEMPLATE = `<div class="cultural-literacy">
          <div class="big-title">
            <span>{{title}}</span>
            <div class="more" onclick="routerlink('/lesson-list/{{more}}/{{id}}')">更多</div>
          </div>
          <ul class="cultural-list">
 {{#each list}}
            <li onclick="routerlink('/lesson-detail/{{id}}')">
              <div class="img-content">
                  <img src="{{cover_img}}" alt="" />
                </div>
                <div class="info">
                  <div class="title">
                    <div class="o2">{{title}}</div>
                  </div>
                  {{#if play_num}}
                  <div class="hits">{{play_num}}</div>
                  {{/if}}
                </div>
            </li>
{{/each}}
          </ul>
        </div>`;

export default {
  name: "moocIndex",
  components: { listtemplate },
  data() {
    return {
      v_key:null,
      aiImg:aiImg,
      primaryIcon: primaryIcon,
      unitName:"",
      active: 0,
      banner: [],
      loading: false,
      finished: true,
      page: 1,
      len: 10,
      Content: [],
      swiper: null, // 存储 swiper 实例
      recommendCwiper: null, //馆内推荐
      typeList: [],
      secondType: [],
      type_id: null,
      courseList: [],
      lastContent: [], //最近更新
      nineContent: [], //90分钟
      templatedata: [], //模板数据
      art_class: 0, //90分钟
      recent_updates: 0, //最近更新
      hot: 0 //热门
    };
  },
  created() {
    this.v_key = this.$route.query.v_key;
    var v_key = this.$route.query.v_key;
    // if (!/Android|webOS|iPhone|iPod|BlackBerry|HarmonyOS|harmonyos/i.test(navigator.userAgent)&&!/HUAWEI/i.test(navigator.userAgent)) {
    //   window.location.href = "/mooc_free_login?v_key=" + v_key;
    // }
    // 真正判断：是不是手机/平板（移动设备）
    const ua = navigator.userAgent || '';
    const isMobile = /Mobile|Android|iPhone|iPod|webOS|BlackBerry|iPad|Tablet/i.test(ua);
    // 如果不是移动设备，才跳PC登录
    if (!isMobile) {
      window.location.href = "/mooc_free_login?v_key=" + v_key;
    }
    //返回重定向
    if (this.$store.state.isLogin == 1 && this.$route.params.openid) {
      this.$router.push("/");
    }
    //是否需要授权登录
    if (this.$route.params.openid) {
      this.$api.get(
        "",
        {
          api: "/wechat/server/get_user_info",
          openid: this.$route.params.openid
        },
        res => {
          if (res.status == 1) {
            this.$store.commit("setLogin");
            this.$store.commit("setfirstlink");
            this.$router.push("/");
            // window.location.href = '/mooc-wx';
          } else {
            console.log("shibai");
          }
        }
      );
    }
    this.$api.get(
      "",
      {
        api: "/v1/mooc_center/get_trial_status"
      },
      res => {
        if (res.status === 1) {
          this.unitName = res.data.center_name;
          this.art_class = res.data.art_class; //90分钟
          this.recent_updates = res.data.recent_updates; //最近更新
          this.hot = res.data.hot; //热门
        }
      }
    );
  },
  mounted() {
    this.getType();
    this.getbanner();
    this.getupdata();
    this.getnine();
    this.getcategory();
  },
  beforeRouteLeave(to, from, next) {
    this.clearHomeTemplateStyle();
    next();
  },
  beforeDestroy() {
    this.clearHomeTemplateStyle();
  },
  methods: {
    clearHomeTemplateStyle() {
      var style = document.getElementById("liststyle");
      if (style) {
        style.innerHTML = "";
      }
    },
    onClick(name) {
      this.active = name;
      if (this.active !== 0) {
        this.secondType = this.typeList.filter(
          item => item.id === this.active
        )[0].children;
        this.finished = false;
        this.loading = true;
        this.page = 1;
        this.courseList = [];
        this.onLoad();
      }
    },
    // 获取分类
    getType() {
      this.$api.get(
        "",
        {
          api: "/v1/Filter/index",
          type: 1
        },
        res => {
          if (res.status === 1) {
            this.typeList = res.data;
          }
        }
      );
    },
    to(name) {
      this.$router.push(name);
    },
    // banner
    getbanner() {
      this.$api.get(
        "",
        {
          api: "/v1/banner/getBanners",
          type: 2
        },
        res => {
          if (res.status === 1) {
            this.banner = res.data;
          }
        }
      );
    },
    // 最近更新
    getupdata() {
      this.$api.get(
        "",
        {
          api: "/v1/home_page/last_update"
        },
        res => {
          if (res.status === 1) {
            this.lastContent = res.data.list;
            this.$nextTick(() => {
              var swiperTime = setInterval(()=>{
                console.log(this.$refs.swiperContainer);
                if(this.$refs.swiperContainer){
                  clearInterval(swiperTime)
                  this.swiper = new Swiper(this.$refs.swiperContainer, {
                    loop: true, // 循环播放
                    slidesPerView: "auto",
                    observer: true,
                    observeParents: true,
                    updateOnImagesReady: true, // ⬅️ 关键：图片加载完后自动更新
                    spaceBetween: 11,
                    autoplay: {
                      delay: 3000, // 自动播放间隔
                      disableOnInteraction: false // 点击后仍自动播放
                    }
                  });
                }
              },300)
            });
          }
        }
      );
    },
    //90分钟
    getnine() {
      this.$api.get(
        "",
        {
          api: "/v1/home_page/recommend"
        },
        res => {
          if (res.status === 1) {
            this.nineContent = res.data.list.slice(0, 4);
          }
        }
      );
    },
    onLoad() {
      this.getlist();
      this.page++;
    },
    getlist() {
      this.$api.get(
        "",
        {
          api: "/v1/course/index",
          type: 1,
          type_id: this.active,
          page: this.page,
          len: this.len,
          status: 1
        },
        res => {
          if (res.status === 1) {
            this.loading = false;
            if (res.data.list.length > 0) {
              this.courseList = this.courseList.concat(res.data.list);
              this.finished = false;
            } else {
              this.finished = true; // 结束加载状态
            }
          }
        }
      );
    },
    getcategory() {
      this.$api.get(
        "",
        {
          api: "/v1/home_page/getcategory",
          type: 2
        },
        res => {
          var data = res.data.map(item => this.normalizeHomeTemplate(item));
          this.templatedata = data;
        }
      );
      this.$api.get(
        "",
        {
          api: "/v1/home_page/getCss",
          type: 2
        },
        res => {
          if (this.$route.name !== "index") {
            return;
          }
          var data = res.data;
          var style = document.getElementById("liststyle");
          if (style) {
            style.innerHTML = data;
          }
        }
      );
    },
    normalizeHomeTemplate(item) {
      var templateId = Number(item.template_id);
      if (templateId === 3 || templateId === 13) {
        return Object.assign({}, item, {
          tpl_html: SPECIALIZED_COURSES_TEMPLATE
        });
      }
      if ((templateId === 2 || templateId === 14) && item.title === "馆内推荐") {
        return Object.assign({}, item, {
          tpl_html: RECOMMEND_TEMPLATE
        });
      }
      if (
        ((templateId === 2 || templateId === 14) && item.title === "文化素养") ||
        templateId === 15
      ) {
        return Object.assign({}, item, {
          tpl_html: CULTURAL_LITERACY_TEMPLATE
        });
      }
      return item;
    }
  }
};
</script>
<style scoped>
.index {
  width: 100%;
  min-height: 100vh;
  padding-top: 0.427rem;
  box-sizing: border-box;
  /* background: linear-gradient(180deg, #ffffff 0%, #f4f5f9 100%); */
  background: linear-gradient(180deg, #FFFFFF 0%, #F4F5F9 50%, #F4F5F9 100%);
}
.index * {
  box-sizing: border-box;
}
.home-search-wrapper,
.tab,
.home-fixed-sections,
.tab-content {
  padding-left: 0.453rem;
  padding-right: 0.453rem;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0.467rem;
  padding: 0 0.667rem;
  width: 100%;
  height: 1.667rem;
  z-index: 99;
}
.footer .footer-content {
  width: 100%;
  height: 100%;
  border-radius: 13.32rem;
  border: 0.027rem solid #ffffff;
  backdrop-filter: blur(0.4rem);
  box-shadow: 0px 0px 0.4rem 0px #94949433;
  /*background: url("./img/footer.png") no-repeat top center;*/
  /* background-color: #FFFFFF; */
  /*background-size: 100% 100%;*/
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.4) 100%);
  backdrop-filter: blur(0.4rem);
  box-shadow: 0px 0px 0.4rem 0px #94949433;
  padding: 0.213rem 1.6rem 0.187rem;
  display: flex;
  justify-content: space-between;
}
.footer .footer-content > div {
  padding-top: 0.813rem;
  font-size: 0.32rem;
  line-height: 0.453rem;
  font-weight: 400;
  text-align: center;
  color: rgba(0, 0, 0, 0.4);
}
.footer .footer-content .home {
  background: url("./img/home.png") no-repeat center 0.133rem;
  background-size: 0.667rem 0.667rem;
  color: #a427f5;
}
.footer .footer-content .my {
  background: url("./img/my.png") no-repeat center 0.133rem;
  background-size: 0.667rem 0.667rem;
}
.home-search-wrapper {
  width: 100%;
  height: 0.96rem;
  display: flex;
  justify-content: space-between;
}
.home-search-wrapper input {
  width: 7.92rem;
  height: 100%;
  border-radius: 0.8rem;
  background: linear-gradient(180deg, #F4F5F9 0%, rgba(255, 255, 255, 0) 100%);
  text-align: center;
  padding: 0 0.267rem;
  color: #111111;
  font-size: 0.48rem;
  line-height: 100%;
  border: 0;
}
.home-search-wrapper .search-btn {
  width: 0.933rem;
  height: 0.933rem;
}
.home-search-wrapper .search-btn img {
  width: 100%;
  height: 100%;
}
.tab {
  position: relative;
  margin-top: 0.427rem;
  margin-bottom: 0.427rem;
}
.tab .shadow {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.853rem;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 50%,
    #ffffff 100%
  );
}
/* index */
.banner {
  width: 100%;
  height: 4rem;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 0.053rem 0.267rem 0px #8888881a;
}
.banner .van-swipe {
  width: 100%;
  height: 100%;
}
.banner .img-content {
  width: 100%;
  height: 100%;
}
.banner .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/deep/ .van-swipe__indicators {
  bottom: 0.267rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0.8rem;
  padding: 0.08rem 0.16rem;
}
/deep/ .van-swipe__indicator {
  width: 0.16rem;
  height: 0.16rem;
  opacity: 0.4;
  background: #ffffff;
  margin-right: 0.093rem;
}
/deep/ .van-swipe__indicator:last-child {
  margin-right: 0;
}
/deep/.banner .van-swipe__indicator--active {
  opacity: 1;
}
.nav {
  padding: 0.4rem 0.48rem;
  background: #ffffff;
  box-shadow: 0px 0px 0.267rem 0px #8888881a;
  margin-top: 0.427rem;
  border-radius: 12px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.533rem;
}
.nav li {
  color: #ffffff;
  font-size: 0.347rem;
  line-height: 0.44rem;
  padding: 1.307rem 0 0.187rem;
  text-align: center;
  text-shadow: 0rem 0rem 0.01rem #00000040;
  letter-spacing: 0.02em;
  font-weight: bold;
}
.nav li:nth-child(1) {
  background: url("./img/1.png") no-repeat top center;
  background-size: 1.653rem 1.933rem;
}
.nav li:nth-child(2) {
  background: url("./img/2.png") no-repeat top center;
  background-size: 1.653rem 1.933rem;
}
.nav li:nth-child(3) {
  background: url("./img/3.png") no-repeat top center;
  background-size: 1.653rem 1.933rem;
}
.nav li:nth-child(4) {
  background: url("./img/4.png") no-repeat top center;
  background-size: 1.653rem 1.933rem;
}
/* 最近更新 */
.updated-swiper {
  width: 100%;
  height: 5.24rem;
}
.updated-swiper .swiper-container {
  width: 100%;
  height: 100%;
}
.updated-swiper .swiper-container .swiper-slide {
  width: 4.133rem;
  height: 4.8rem;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 0.053rem 0.453rem 0px #2119230a;
}
.updated-swiper .swiper-container .img-content {
  position: relative;
  width: 100%;
  height: 2.4rem;
}
.updated-swiper .swiper-container .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}
.updated-swiper .img-content .chapter {
  position: absolute;
  top: 0.12rem;
  left: 0.12rem;
  padding: 0 0.187rem;
  background: rgba(9, 9, 9, 0.3);
  font-size: 0.267rem;
  color: #ffffff;
  line-height: 0.4rem;
  font-weight: 400;
  border-radius: 13.32rem;
}
.updated-swiper .title {
  height: 1.467rem;
  padding: 0.213rem;
  font-size: 0.4rem;
  line-height: 130%;
  color: #111111;
  font-weight: 400;
}
.updated-swiper .teacher {
  padding: 0.133rem 0.213rem 0.213rem;
  display: flex;
  justify-content: space-between;
  line-height: 0.547rem;
  font-weight: 400;
}
.updated-swiper .teacher-name {
  display: flex;
  font-size: 0.32rem;
  color: #131b26;
}
.updated-swiper .teacher-thumb {
  width: 0.547rem;
  height: 0.547rem;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 0.187rem;
}
.updated-swiper .teacher-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.updated-swiper .teacher .job {
  width: 1.733rem;
  font-size: 0.32rem;
  color: #8a8b99;
  text-align: right;
}
/* 90分钟艺课堂 */
.art-classroom .big-title{
  margin-top: .44rem;
}
.art-classroom .art-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.373rem;
}
.art-classroom li {
  position: relative;
  height: 2.653rem;
  border-radius: 12px;
  overflow: hidden;
}
.art-classroom li .img-content {
  width: 100%;
  height: 100%;
}
.art-classroom li .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.art-classroom li .list-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1.24rem 0.267rem 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.0001) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
}
.art-classroom li .title {
  font-size: 0.373rem;
  line-height: 0.52rem;
  color: #ffffff;
  font-weight: 600;
}
.art-classroom li .hits {
  padding-left: 0.453rem;
  font-size: 0.347rem;
  line-height: 0.48rem;
  color: #ffffff;
  font-weight: 400;
  margin-top: 0.12rem;
  background: url("./img/hits.png") no-repeat left center;
  background-size: 0.32rem 0.32rem;
}
/* ------------------------tab-------------------- */
/deep/ .van-tabs__nav--line.van-tabs__nav--complete {
  padding-left: 0;
  padding-right: 0;
}
/deep/ .van-tabs__nav--line {
  padding-bottom: 0;
}
/deep/ .van-tabs__line {
  bottom: 0;
}
/deep/ .van-tab {
  font-size: 0.427rem !important;
  color: #333333;
  line-height: 0.453rem;
  font-weight: 400;
  padding: 0 0.32rem .2rem;
  white-space: nowrap;
}
/deep/ .van-tab--active {
  color: #333333;
  font-size: 0.427rem;
  line-height: 0.44rem;
  font-weight: 600;
}
/deep/ .van-tabs--line .van-tabs__wrap {
  height: .8rem;
}

/* ---------------------------------------------- */
.tab-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.133rem;
  padding: 0.4rem 0.34rem;
  box-shadow: 0px 0px 0.267rem 0px #8888880d;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 0.707rem;
}
.tab-list li {
  text-align: center;
}
.tab-list li .img-content {
  width: 0.8rem;
  height: 0.8rem;
  margin: 0 auto;
}
.tab-list li .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tab-list li .name {
  color: #333333;
  font-size: 0.373rem;
  line-height: 0.52rem;
  margin-top: 0.187rem;
}
/* 公共的title */
.small-title {
  display: flex;
  justify-content: space-between;
  line-height: 0.72rem;
  margin-bottom: 0.24rem;
}
.small-title span {
  color: #333333;
  font-size: 0.507rem;
  font-family: "FZLTCHJW";
  background: url("./img/title-bg.png") no-repeat bottom center;
  background-size: 0.867rem 0.2rem;
  letter-spacing: 0.08em;
}
.small-title .more{
  font-size: 0.347rem;
  color: #35445d;
  padding-right: 0.453rem;
  background: url("./img/more.png") no-repeat center right;
  background-size: 0.427rem 0.427rem;
}
.course-list-scrool {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.4rem;
}
.course-list-scrool li {
  box-shadow: 0px 0.053rem 0.48rem 0px #2119231a;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}
.course-list-scrool .img-content {
  position: relative;
  width: 100%;
  height: 2.56rem;
}
.course-list-scrool .img-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}
.course-list-scrool .img-content .chapter {
  position: absolute;
  top: 0.12rem;
  left: 0.12rem;
  padding: 0 0.2rem;
  font-size: 0.293rem;
  color: #ffffff;
  line-height: 0.427rem;
  border-radius: 0.72rem;
  background: #0909094d;
}
.course-list-scrool .info {
  padding-bottom: 0;
  border-bottom: 0;
}
.course-list-scrool .info .title {
  height: 1.547rem;
  padding: 0.24rem;
  color: #111111;
  font-size: 0.4rem;
  line-height: 130%;
  font-weight: 400;
}
.course-list-scrool .teacher {
  padding: 0.133rem 0.24rem 0.267rem;
  line-height: 0.587rem;
  display: flex;
  justify-content: space-between;
}
.course-list-scrool .teacher-name {
  color: #131b26;
  font-size: 0.32rem;
  display: flex;
  margin-right: 0.133rem;
}
.course-list-scrool .teacher-thumb {
  width: 0.587rem;
  height: 0.587rem;
  border-radius: 50%;
  margin-right: 0.187rem;
  overflow: hidden;
}
.course-list-scrool .teacher-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.course-list-scrool .job {
  width: 1.72rem;
  color: #8a8b99;
  font-size: 0.32rem;
  text-align: right;
}
/* 仅覆盖首页配置模板 temp-data，不影响搜索页、课程列表 */
.temp-data{
  padding: 0 0.453rem 0 0.453rem;
}
.temp-data /deep/ .group-title {
  display: block !important;
  /* padding: 0 0.453rem 0 0.453rem; */
}
.temp-data /deep/ .group-title.f-cb:after {
  display: block;
  content: "";
  clear: both;
  height: 0;
  overflow: hidden;
}
.temp-data /deep/ .group-title-text {
  float: left;
}
.temp-data /deep/ .group-title-all {
  float: right;
  padding-right: 0.453rem;
  background: url("./img/more.png") no-repeat center right;
  background-size: 0.427rem 0.427rem;
}
.temp-data /deep/ .lesson2-items {
  /* margin: 0 0.4rem 0 0.4rem; */
  padding-left: 0;
  gap: 0.2rem;
}
.temp-data /deep/ .lesson2 ,.temp-data /deep/ .collection {
  padding-bottom: 0.3rem;
}
.temp-data /deep/ .lesson2-item {
  margin-left: 0;
  margin-top: 0;
}
.temp-data /deep/ .collection-item {
  margin-top: 0;
  margin-bottom: 0.4rem;
  margin-right: 0;
  margin-left: 0;
}
.temp-data /deep/ .collection-content {
  padding-left: 0.2rem;
}
.temp-data /deep/ .lesson2-main,
.temp-data /deep/ .collection-left,
.temp-data /deep/ .collection-left-text,
.temp-data /deep/ .specialized-courses .img-list .border1,
.temp-data /deep/ .specialized-courses .img-list .border2,
.temp-data /deep/ .specialized-courses .img-list .img-content,
.temp-data /deep/ .specialized-courses .special-content,
.temp-data /deep/ .recommend-swiper .swiper-slide,
.temp-data /deep/ .recommend-swiper .swiper-item .img-content,
.temp-data /deep/ .cultural-list,
.temp-data /deep/ .cultural-list li .img-content {
  border-radius: 12px;
}
.temp-data /deep/ .template-id-15 .cultural-list li:nth-child(n + 4), .temp-data /deep/ .template-id-2 .cultural-list li:nth-child(n + 4) {
  display: none;
}
.all-lesson {
  height: 1.52rem;
  line-height: 1.52rem;
  text-align: center;
  color: #EC6D3A;
  font-size: 0.373rem;
  letter-spacing: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/index/index.vue